document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.getElementById('menu-drawer');
  const toggleBtn = document.getElementById('menu-toggle');
  const overlay = document.getElementById('MenuOverlay');
  const backHeader = document.getElementById('mobile-submenu-header');
  const submenuTitle = document.getElementById('submenu-title');
  const menuLeft = document.querySelector('.menu-column-left');

  // Abrir/Cerrar Drawer
  toggleBtn.addEventListener('click', () => {
    const isOpen = drawer.classList.contains('open');

    if (!isOpen) {
      window.ClarezaDrawers?.open('menu');
      drawer.classList.add('open');
      toggleBtn.classList.add('open');
      overlay.style.display = 'block';
      document.body.style.overflow = 'hidden';
    } else {
      drawer.classList.remove('open');
      toggleBtn.classList.remove('open');
      overlay.style.display = 'none';
      document.body.style.overflow = '';
    }

    drawer.classList.remove('submenu-open');
    drawer.classList.remove('submenu-active');
    menuLeft.classList.remove('hidden');
    document.querySelectorAll('.menu-sub').forEach((menu) => menu.classList.remove('active'));
    document.querySelectorAll('.menu-link').forEach((link) => link.classList.remove('active'));
  });

  // Submenús
  document.querySelectorAll('.menu-link[data-target]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const targetId = btn.getAttribute('data-target');
      const targetMenu = document.getElementById(targetId);

      document.querySelectorAll('.menu-sub').forEach((menu) => menu.classList.remove('active'));
      document.querySelectorAll('.menu-link').forEach((link) => link.classList.remove('active'));

      btn.classList.add('active');
      if (targetMenu) targetMenu.classList.add('active');

      if (window.innerWidth <= 767) {
        drawer.classList.add('submenu-open');
        submenuTitle.textContent = btn.textContent;

        setTimeout(() => {
          menuLeft.classList.add('hidden');
        }, 400); // esperar a que termine la animación
      } else {
        drawer.classList.add('submenu-active');
      }
    });
  });

  // Regresar al menú principal tocando el header completo (← + texto)
  backHeader.addEventListener('click', () => {
    drawer.classList.remove('submenu-open');
    menuLeft.classList.remove('hidden');

    document.querySelectorAll('.menu-sub').forEach((menu) => menu.classList.remove('active'));
    document.querySelectorAll('.menu-link').forEach((link) => link.classList.remove('active'));
  });

  // Cerrar tocando overlay
  overlay.addEventListener('click', () => {
    toggleBtn.click();
  });
});

const toggle = document.getElementById('client-services-toggle');
const menu = document.getElementById('client-services-menu');
const drawer = document.getElementById('menu-drawer');
const chevron = toggle.querySelector('.chevron2');

toggle.addEventListener('click', function (e) {
  e.preventDefault();
  const isOpen = menu.classList.contains('open');

  menu.classList.toggle('open');
  toggle.classList.toggle('active-toggle');
  chevron.classList.toggle('up', !isOpen); // Si está cerrado, va a "up"

  if (window.innerWidth <= 767 && !isOpen) {
    drawer.classList.add('submenu-active');
  }

  if (window.innerWidth <= 767 && isOpen) {
    drawer.classList.remove('submenu-active');
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.header-custom');
  const menuToggle = document.getElementById('menu-toggle');

  if (header && header.classList.contains('transparent')) {
    menuToggle.classList.add('light');
  }
});
